import { useState, useEffect, useContext } from 'react'
import { MQTT_TOPIC } from 'constants/appConstants'
import { mqttPublish } from 'services/mqtt-service'
import { MqttClientContext } from 'components/system/app'

const useVideoPlayer = (videoElement, contentType, contentId, video) => {
  const [payload, setPayload] = useState({})

  const mqttClient = useContext(MqttClientContext)

  const screenSelected = JSON.parse(localStorage.getItem('screenApp'))

  const topic = `${MQTT_TOPIC}${screenSelected?.value}`

  mqttClient.on('message', (topic, message) => {
    setPayload({ topic, message: message.toString() })
  })

  const publish = (command, data) => {
    if (mqttClient) {
      const message = JSON.stringify({ command, data })
      mqttPublish(mqttClient, topic, message)
    }
  }

  const [playerState, setPlayerState] = useState({
    isPlaying: false,
    progress: 0,
    speed: 1,
    isMuted: true,
  })

  useEffect(() => {
    setPlayerState({ isPlaying: false, progress: 0, speed: 1, isMuted: true })
  }, [contentId, video])

  const togglePlay = () => {
    setPlayerState({
      ...playerState,
      isPlaying: !playerState.isPlaying,
    })

    playerState.isPlaying
      ? publish('pause', {
          contentType,
          contentId,
          currentTime: videoElement.current.currentTime,
          totalTime: videoElement.current.duration,
        })
      : publish('play', {
          contentType,
          contentId,
          currentTime: videoElement.current.currentTime,
          totalTime: videoElement.current.duration,
        })
  }

  useEffect(() => {
    playerState.isPlaying ? videoElement.current.play() : videoElement.current.pause()
  }, [playerState.isPlaying, videoElement])

  const handleOnTimeUpdate = () => {
    if (!Number.isNaN(videoElement.current?.currentTime) && !Number.isNaN(videoElement.current?.duration)) {
      const progress = (videoElement.current.currentTime / videoElement.current.duration) * 100
      setPlayerState({
        ...playerState,
        progress,
      })
    }
  }

  const handleVideoProgress = event => {
    const manualChange = Number(event.target.value)
    videoElement.current.currentTime = (videoElement.current.duration / 100) * manualChange
    setPlayerState({
      ...playerState,
      progress: manualChange,
    })

    playerState.isPlaying
      ? publish('play', {
          contentType,
          contentId,
          currentTime: videoElement.current.currentTime,
          totalTime: videoElement.current.duration,
        })
      : publish('pause', {
          contentType,
          contentId,
          currentTime: videoElement.current.currentTime,
          totalTime: videoElement.current.duration,
        })
  }

  const toggleMute = () => {
    setPlayerState({
      ...playerState,
      isMuted: !playerState.isMuted,
    })
  }

  useEffect(() => {
    playerState.isMuted ? (videoElement.current.muted = true) : (videoElement.current.muted = false)
  }, [playerState.isMuted, videoElement])

  return {
    playerState,
    togglePlay,
    handleOnTimeUpdate,
    handleVideoProgress,
    toggleMute,
  }
}

export default useVideoPlayer
